<div class="" (click)="onDocumentClick($event)">

<div class="table-section">

  <!-- Main Content Container -->
  <div class="ranking-panel">
    <!-- Header Section - Two Row Layout -->
    <div class="header-section">
      <!-- Row 1: Title and Dropdowns -->
      <div class="header-row-1">
        <div class="title-content">
          <div class="main-title">Store Ranking - Detailed Report</div>
          <div class="subtitle">Ranking by Sales Data</div>
        </div>
        <div class="header-controls">
          <!-- Right: Selected Store on Top toggle -->
        <div class="toggle-switch-container" (click)="toggleSelectedStoreAlwaysOnTop()">
          <div class="toggle-switch" [class.on]="selectedStoreAlwaysOnTop">
            <div class="toggle-knob"></div>
          </div>
          <span class="toggle-label">Selected Store on Top</span>
        </div>
          <!-- Filter Button -->
          <button class="action-btn filter-btn" [class.has-filters]="hasAppliedFilters()" (click)="selectFilterLocationOption('All Locations')">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Filters</span>
            <span class="filter-badge" *ngIf="hasAppliedFilters()">{{ getAppliedFilterChips().length }}</span>
          </button>
  <div class="segmented-control">
            <button class="segment-btn"
                    [class.active]="!showAsAnnualSales"
                    (click)="showAsAnnualSales ? toggleSalesView(false) : null">
              Weekly Sales
            </button>
            <button class="segment-btn"
                    [class.active]="showAsAnnualSales"
                    (click)="!showAsAnnualSales ? toggleSalesView(true) : null">
              Annual Sales
            </button>
          </div>
          <!-- Export Dropdown -->
          <div class="export-dropdown" (click)="$event.stopPropagation()"
               [class.export-disabled]="!hasExportData">
            <div class="export-tooltip-anchor" [class.show-tooltip]="!hasExportData">
              <button class="action-btn export-btn"
                      [disabled]="!hasExportData || isExporting"
                      (click)="toggleExportDropdown($event)">
                <ng-container *ngIf="!isExporting">
                  <img src="assets/images/download-icon.svg" class="export-btn-icon" width="13" height="13" alt="Export">
                  <span>Export</span>
                  <svg class="chevron-icon" width="11" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.26465 4.19116L5.88232 6.80884L8.5 4.19116" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </ng-container>
                <ng-container *ngIf="isExporting">
                  <span class="export-btn-spinner" aria-hidden="true"></span>
                  <span>Exporting…</span>
                </ng-container>
              </button>
              <div class="export-no-data-tooltip">
                <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M8 5v3.5M8 11h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                Insufficient data for export
              </div>
            </div>
            <div class="export-dropdown-options" [class.open]="exportDropdownOpen && hasExportData">
              <div class="export-dropdown-option" (click)="selectExportOption('Export to CSV')">
                <img src="assets/images/csv-icon.svg" alt="CSV" width="16" height="16">
                CSV
              </div>
              <div class="export-dropdown-option" (click)="selectExportOption('Export to Excel')">
                <img src="assets/images/excel-icon.svg" alt="Excel" width="16" height="16">
                Excel
              </div>
              <div class="export-dropdown-option" (click)="selectExportOption('Export to PDF')">
                <img src="assets/images/pdf-icon.svg" alt="PDF" width="16" height="16">
                PDF
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- Row 2: Sales Toggle, Filter Chips, and Store Toggle -->
      <div class="header-row-2">
        <!-- Left group: segmented control + active filter chips -->
        <div class="row2-left">
          <!-- Segmented Control: Sales Type -->

          <!-- Filter chips (only shown when filters are active) -->
          <div class="filter-chips-list" *ngIf="hasAppliedFilters()">
            <div class="filter-chip"
                 *ngFor="let chip of getAppliedFilterChips()"
                 (click)="openFilterWithCategory(chip.category)">
              <span class="chip-dot"></span>
              <span class="chip-label">{{ chip.label }}</span>
              <span class="chip-remove" (click)="clearFilterCategory(chip.category); $event.stopPropagation()">
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
          </div>
        </div>


      </div>

    <!-- Table Section -->
    <div class="table-section">
      <!-- Sales Volume Filter -->
      <mtn-sales-volume-filter
        [isVisible]="showSalesVolumeFilter"
        (close)="onSalesVolumeFilterClose()"
        (apply)="onSalesVolumeFilterApply($event)"
        (reset)="onSalesVolumeFilterReset()">
      </mtn-sales-volume-filter>

      <!-- Sort indicator for every sortable column header: dual arrows while the column
           is inactive, a single direction arrow once it is the active sort. Declared once
           and stamped per column (GRO-865 took the sortable columns from four to nine,
           and the arrow paths are too long to repeat that many times). -->
      <ng-template #sortIcon let-column>
        <!-- Dual arrows for default state -->
        <svg *ngIf="getSortIconClass(column) === 'sort-icon sort-default'" [class]="getSortIconClass(column)" width="14" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.92529 0.370605C5.40854 0.370605 5.80029 0.76236 5.80029 1.24561V9.63318L7.80658 7.62689C8.14827 7.28521 8.70232 7.28521 9.04401 7.62689C9.38569 7.96858 9.38569 8.52263 9.04401 8.86432L5.54401 12.3643C5.2023 12.706 4.64829 12.706 4.30657 12.3643L0.806572 8.86432C0.464867 8.52263 0.464867 7.96858 0.806572 7.62689C1.14829 7.28521 1.7023 7.28521 2.04401 7.62689L4.05029 9.63318V1.24561C4.05029 0.76236 4.44205 0.370605 4.92529 0.370605ZM13.0566 0.626884C13.3983 0.285179 13.9523 0.285179 14.294 0.626884L17.794 4.12688C18.1357 4.4686 18.1357 5.02263 17.794 5.36432C17.4523 5.70601 16.8983 5.70601 16.5566 5.36432L14.5503 3.35804V11.7456C14.5503 12.2289 14.1586 12.6206 13.6753 12.6206C13.192 12.6206 12.8003 12.2289 12.8003 11.7456V3.35804L10.794 5.36432C10.4523 5.70601 9.89827 5.70601 9.55658 5.36432C9.21489 5.02263 9.21489 4.4686 9.55658 4.12688L13.0566 0.626884Z" fill="#838383"/>
        </svg>
        <!-- Single arrow for active state -->
        <svg *ngIf="getSortIconClass(column) !== 'sort-icon sort-default'" [class]="getSortIconClass(column)" width="14" height="10" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.37549 0.370605C9.85873 0.370605 10.2505 0.76236 10.2505 1.24561V9.63318L12.2568 7.62689C12.5985 7.28521 13.1525 7.28521 13.4942 7.62689C13.8359 7.96858 13.8359 8.52263 13.4942 8.86432L9.99421 12.3643C9.6525 12.706 9.09848 12.706 8.75677 12.3643L5.25677 8.86432C4.91506 8.52263 4.91506 7.96858 5.25677 7.62689C5.59848 7.28521 6.1525 7.28521 6.49421 7.62689L8.50049 9.63318V1.24561C8.50049 0.76236 8.89224 0.370605 9.37549 0.370605Z" fill="white"/>
        </svg>
      </ng-template>

      <div class="table-container" *ngIf="!showSalesVolumeFilter">
        <!-- Table Header -->
        <div class="table-header">
          <div class="table-header-row">
            <div class="header-cell location-name-cell">
              <div class="header-cell-label single-label-header">Location Name</div>
            </div>
            <div class="header-cell annual-sales-cell">
              <div class="header-cell-label single-label-header">{{ getSalesColumnTitle() }}</div>
            </div>
            <!-- NATL Rank Column - Stacked Layout -->
            <div class="header-cell rank-cell" (click)="sortBy('nationalRank')">
              <div class="stacked-header">
                <span class="header-label-top">NATL</span>
                <span class="header-label-top">Rank</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'nationalRank' }"></ng-container>
            </div>

            <!-- State Rank Column - Stacked Layout -->
            <div class="header-cell rank-cell" (click)="sortBy('stateRank')">
              <div class="stacked-header">
                <span class="header-label-top">State</span>
                <span class="header-label-top">Rank</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'stateRank' }"></ng-container>
            </div>

            <!-- County Rank Column - Stacked Layout -->
            <div class="header-cell rank-cell" (click)="sortBy('countyRank')">
              <div class="stacked-header">
                <span class="header-label-top">County</span>
                <span class="header-label-top">Rank</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'countyRank' }"></ng-container>
            </div>

            <!-- CBSA Rank Column - Stacked Layout -->
            <div class="header-cell rank-cell" (click)="sortBy('msaRank')">
              <div class="stacked-header">
                <span class="header-label-top">CBSA</span>
                <span class="header-label-top">Rank</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'msaRank' }"></ng-container>
            </div>

            <!-- Miles Column - Stacked Layout with Dropdown + sort (GRO-865).
                 The trade-area dropdown stops propagation, so picking a radius from it
                 never doubles as a sort click. -->
            <div class="header-cell filter-cell" (click)="sortBy('miles')">
              <div class="stacked-filter-header">
                <div class="miles-filter-dropdown" (click)="$event.stopPropagation()">
                  <div class="miles-filter" (click)="toggleMilesDropdown($event)">
                    <span class="filter-value">{{ selectedMilesOption }}</span>
                    <svg class="filter-arrow" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.2621 3.12322C2.97623 3.57165 2.32145 3.57165 2.03558 3.12321L0.88534 1.31891C0.576702 0.834766 0.924452 0.200677 1.4986 0.200677L3.79907 0.200677C4.37323 0.200678 4.72098 0.834767 4.41234 1.31891L3.2621 3.12322Z" fill="#D9D9D9"/>
                    </svg>
                  </div>
                  <div class="filter-dropdown-options" [class.open]="milesDropdownOpen">
                    <div class="filter-dropdown-option" *ngFor="let option of milesOptions" (click)="selectMilesOption(option)">{{ option }} mi</div>
                  </div>
                </div>
                <span class="header-label-top">Miles</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'miles' }"></ng-container>
            </div>

            <!-- Minutes Column - Stacked Layout with Dropdown + sort (GRO-865) -->
            <div class="header-cell filter-cell" (click)="sortBy('minutes')">
              <div class="stacked-filter-header">
                <div class="minutes-filter-dropdown" (click)="$event.stopPropagation()">
                  <div class="minutes-filter" (click)="toggleMinutesDropdown($event)">
                    <span class="filter-value">{{ selectedMinutesOption }}</span>
                    <svg class="filter-arrow" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.51747 3.12322C2.2316 3.57165 1.57682 3.57165 1.29095 3.12321L0.140711 1.31891C-0.167927 0.834766 0.179823 0.200677 0.753976 0.200677L3.05444 0.200677C3.6286 0.200678 3.97635 0.834767 3.66771 1.31891L2.51747 3.12322Z" fill="#D9D9D9"/>
                    </svg>
                  </div>
                  <div class="filter-dropdown-options" [class.open]="minutesDropdownOpen">
                    <div class="filter-dropdown-option" *ngFor="let option of minutesOptions" (click)="selectMinutesOption(option)">{{ option }} min</div>
                  </div>
                </div>
                <span class="header-label-top">Minutes</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'minutes' }"></ng-container>
            </div>

            <!-- Store FIT Category Column - Stacked Layout, alphabetical sort (GRO-865) -->
            <div class="header-cell fit-category-cell" (click)="sortBy('fitType')">
              <div class="stacked-header">
                <span class="header-label-top">Store FIT</span>
                <span class="header-label-top">Category</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'fitType' }"></ng-container>
            </div>

            <!-- Store Size Column - Stacked Layout, numeric sort (GRO-865); area follows the user's Sales SQFT preference (GRO-911) -->
            <div class="header-cell store-size-cell" (click)="sortBy('sqft')">
              <div class="stacked-header">
                <span class="header-label-top">Store Size</span>
                <span class="header-label-top">({{ storeSizeLabel }})</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'sqft' }"></ng-container>
            </div>

            <!-- Distance (Miles) Column - Stacked Layout, numeric sort (GRO-865) -->
            <div class="header-cell distance-cell" (click)="sortBy('distanceMiles')">
              <div class="stacked-header">
                <span class="header-label-top">Distance</span>
                <span class="header-label-top">(Miles)</span>
              </div>
              <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'distanceMiles' }"></ng-container>
            </div>
          </div>

          <!-- Table Body -->
          <div class="table-body" [class.table-body--has-data]="!isLoading && !loadingError && tableData.length > 0">

            <!-- Loading state -->
            <div class="table-body-state" *ngIf="isLoading">
              <div class="state-spinner"></div>
              <span class="state-text">Loading ranking data...</span>
            </div>

            <!-- Error state -->
            <div class="table-body-state" *ngIf="!isLoading && loadingError">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#f87171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="state-text state-error-text">{{ loadingError }}</span>
              <button class="state-retry-btn" (click)="loadComprehensiveRankingData()">Retry</button>
            </div>

            <!-- Empty state -->
            <div class="table-body-state empty-state" *ngIf="!isLoading && !loadingError && tableData.length === 0">
              <div class="empty-state-icon-wrap">
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <!-- clipboard body -->
                  <rect x="7" y="10" width="30" height="30" rx="3.5" stroke="rgba(99,130,200,0.32)" stroke-width="2"/>
                  <!-- clipboard top tab -->
                  <path d="M15 10V7a1 1 0 011-1h12a1 1 0 011 1v3" stroke="rgba(99,130,200,0.32)" stroke-width="2" stroke-linecap="round"/>
                  <!-- empty row lines -->
                  <line x1="13" y1="21" x2="31" y2="21" stroke="rgba(99,130,200,0.22)" stroke-width="1.8" stroke-linecap="round"/>
                  <line x1="13" y1="27" x2="26" y2="27" stroke="rgba(99,130,200,0.16)" stroke-width="1.8" stroke-linecap="round"/>
                  <line x1="13" y1="33" x2="28" y2="33" stroke="rgba(99,130,200,0.11)" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="state-text empty-state-title">No records found</span>
            </div>

            <div class="table-row" *ngFor="let item of (isLoading ? [] : tableData)" [class.selected-row]="item.isSelected"
                 (mouseenter)="onRowHover(item, true)"
                 (mouseleave)="onRowHover(item, false)">
              <!-- Location Name Cell -->
              <div class="table-cell location-name-cell" (click)="openDetailReport(item)">
                <div class="location-content">

                 <div *ngIf="bannerLogoUrl"
                       class="store-logo-wrap"
                        >
                    <img [src]="bannerLogoUrl"
                         [alt]="store?.banner?.name"
                         class="store-logo-img"/>
                  </div>
                  <svg *ngIf="item.storeType === 'other'" class="store-icon other-store-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="10.3995" cy="9.97865" rx="9.60456" ry="9.94105" fill="#D9D9D9"/>
                    <path d="M6.44482 14.9227V4.71582H7.63897V9.77938H7.75454L12.1844 4.71582H13.7445L9.60354 9.32087L13.7445 14.9227H12.3L8.87165 10.1781L7.63897 11.6134V14.9227H6.44482Z" fill="black"/>
                  </svg>
                  <div class="location-info">
                    <div class="location-info-content">
                      <div class="name-with-badge">
                        <span class="store-name">{{ item.name }}</span>
                        <div *ngIf="item.isSelected" class="selected-badge">Selected Store</div>
                      </div>
                      <div class="store-address">{{ item.address }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Annual Sales Cell -->
              <div class="table-cell annual-sales-cell">
                <div [ngClass]="{
                  'sales-value-success':item.isHovered,
                  'sales-value':!item.isHovered
                }">
                  <div class="sales-amount">{{ item.annualSales }}</div>
                </div>
              </div>

              <!-- NATL Rank Cell -->
              <div class="table-cell natl-rank-cell" (click)="openDetailReport(item)">
                <div class="ranking-cell-content" >
                  <div class="responsive-ranking">
                    <div class="ranking-badge"  [ngClass]="getRankingBadgeClass(item.nationalRank, item.nationalRankTotal, item.nationalBand)"
                    [class.ranking-badge-hover]="item.isHovered">
                      {{ getRankDisplay(item.nationalRank, item.nationalRankTotal, item.isHovered,item.isSelected) }}
                    </div>
                    <svg class="expand-icon" [style.opacity]="item.isHovered ? '0.7' : '0'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.04411 4.82039L11.7524 2.11206M11.7524 2.11206H9.04411M11.7524 2.11206V4.82039M4.71077 4.82039L2.00244 2.11206M2.00244 2.11206V4.82039M2.00244 2.11206H4.71077M4.71077 9.15373L2.00244 11.8621M2.00244 11.8621H4.71077M2.00244 11.8621V9.15373M9.04411 9.15373L11.7524 11.8621M11.7524 11.8621V9.15373M11.7524 11.8621H9.04411" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- State Rank Cell -->
              <div class="table-cell county-rank-cell"  (click)="openDetailReport(item)">
                <div class="ranking-cell-content">
                  <div class="responsive-ranking">
                    <div class="ranking-badge"  [ngClass]="getRankingBadgeClass(item.stateRank, item.stateRankTotal, item.stateBand)"
                    [class.ranking-badge-hover]="item.isHovered">
                      {{ getRankDisplay(item.stateRank, item.stateRankTotal, item.isHovered,item.isSelected) }}
                    </div>
                    <svg class="expand-icon" [style.opacity]="item.isHovered ? '0.7' : '0'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.98844 4.82039L11.6968 2.11206M11.6968 2.11206H8.98844M11.6968 2.11206V4.82039M4.65511 4.82039L1.94678 2.11206M1.94678 2.11206V4.82039M1.94678 2.11206H4.65511M4.65511 9.15373L1.94678 11.8621M1.94678 11.8621H4.65511M1.94678 11.8621V9.15373M8.98844 9.15373L11.6968 11.8621M11.6968 11.8621V9.15373M11.6968 11.8621H8.98844" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- County Rank Cell -->
              <div class="table-cell county-rank-cell" (click)="openDetailReport(item)">
                <div class="ranking-cell-content" >
                  <div class="responsive-ranking">
                    <div class="ranking-badge"  [ngClass]="getRankingBadgeClass(item.countyRank, item.countyRankTotal, item.countyBand)"
                    [class.ranking-badge-hover]="item.isHovered">
                      {{ getRankDisplay(item.countyRank, item.countyRankTotal, item.isHovered,item.isSelected) }}
                    </div>
                    <svg class="expand-icon" [style.opacity]="item.isHovered ? '0.7' : '0'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.19206 4.82039L11.9004 2.11206M11.9004 2.11206H9.19206M11.9004 2.11206V4.82039M4.85872 4.82039L2.15039 2.11206M2.15039 2.11206V4.85872M2.15039 2.11206H4.85872M4.85872 9.15373L2.15039 11.8621M2.15039 11.8621H4.85872M2.15039 11.8621V9.15373M9.19206 9.15373L11.9004 11.8621M11.9004 11.8621V9.15373M11.9004 11.8621H9.19206" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- MSA Rank Cell -->
              <div class="table-cell msa-rank-cell" (click)="openDetailReport(item)">
                <div class="ranking-cell-content" >
                  <div class="responsive-ranking">
                    <div class="ranking-badge"  [ngClass]="getRankingBadgeClass(item.msaRank, item.msaRankTotal, item.msaBand)"
                    [class.ranking-badge-hover]="item.isHovered">
                      {{ getRankDisplay(item.msaRank, item.msaRankTotal, item.isHovered,item.isSelected) }}
                    </div>
                    <svg class="expand-icon" [style.opacity]="item.isHovered ? '0.7' : '0'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.2155 4.82039L11.9238 2.11206M11.9238 2.11206H9.2155M11.9238 2.11206V4.82039M4.88216 4.82039L2.17383 2.11206M2.17383 2.11206V4.82039M2.17383 2.11206H4.88216M4.88216 9.15373L2.17383 11.8621M2.17383 11.8621H4.88216M2.17383 11.8621V9.15373M9.2155 9.15373L11.9238 11.8621M11.9238 11.8621V9.15373M11.9238 11.8621H9.2155" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Miles Cell -->
              <div class="table-cell miles-cell" (click)="openDetailReport(item)">
                <div class="ranking-cell-content" >
                  <div class="responsive-ranking">
                    <div class="ranking-badge"  [ngClass]="getRankingBadgeClass(item.miles, item.milesTotal, item.milesBand)"
                    [class.ranking-badge-hover]="item.isHovered">
                      {{ getRankDisplay(item.miles, item.milesTotal, item.isHovered,item.isSelected) }}
                    </div>
                    <svg class="expand-icon" [style.opacity]="item.isHovered ? '0.7' : '0'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.15983 4.82039L11.8682 2.11206M11.8682 2.11206H9.15983M11.8682 2.11206V4.82039M4.8265 4.82039L2.11816 2.11206M2.11816 2.11206V4.82039M2.11816 2.11206H4.8265M4.8265 9.15373L2.11816 11.8621M2.11816 11.8621H4.8265M2.11816 11.8621V9.15373M9.15983 9.15373L11.8682 11.8621M11.8682 11.8621V9.15373M11.8682 11.8621H9.15983" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Minutes Cell -->
              <div class="table-cell minutes-cell" (click)="openDetailReport(item)">
                <div class="ranking-cell-content" >
                  <div class="responsive-ranking">
                    <div class="ranking-badge"  [ngClass]="getRankingBadgeClass(item.minutes, item.minutesTotal, item.minutesBand)"
                    [class.ranking-badge-hover]="item.isHovered">
                      {{ getRankDisplay(item.minutes, item.minutesTotal, item.isHovered,item.isSelected) }}
                    </div>
                    <svg class="expand-icon" [style.opacity]="item.isHovered ? '0.7' : '0'"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.23356 4.82039L11.9419 2.11206M11.9419 2.11206H9.23356M11.9419 2.11206V4.82039M4.90023 4.82039L2.19189 2.11206M2.19189 2.11206V4.82039M2.19189 2.11206H4.90023M4.90023 9.15373L2.19189 11.8621M2.19189 11.8621H4.90023M2.19189 11.8621V9.15373M9.23356 9.15373L11.9419 11.8621M11.9419 11.8621V9.15373M11.9419 11.8621H9.23356" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Store FIT Category Cell -->
              <div class="table-cell fit-category-cell" (click)="openDetailReport(item)">
                <span class="cell-text-value">{{ getFitDisplay(item.fitType) }}</span>
              </div>

              <!-- Store Size Cell -->
              <div class="table-cell store-size-cell" (click)="openDetailReport(item)">
                <span class="cell-text-value">{{ item.sqft ? (item.sqft | number) + ' sqft' : 'N/A' }}</span>
              </div>

              <!-- Distance (Miles) Cell — dash on the selected store's own row -->
              <div class="table-cell distance-cell" (click)="openDetailReport(item)">
                <span class="cell-text-value">{{ getDistanceDisplay(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- Hidden Pagination Section (no longer needed) -->
    <!-- <div class="pagination-section" style="display: none;"> ... </div> -->

    <!-- Pagination Section -->

  </div>
   <!-- Footer Section -->
  </div>
  <div class="footer-section">
    <!-- Top Row: Page size picker + range text + coverage -->
    <div class="footer-top-row">
      <div class="footer-left">
        <span class="showing-stores">Rows per page</span>
        <div class="pagination-dropdown" (click)="$event.stopPropagation()">
          <div class="pagination-dropdown-button" (click)="togglePaginationDropdown($event)">
            <span>{{ pageSize }}</span>
            <svg class="chevron-icon" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.88232 4.62256L5.5 7.24023L8.11768 4.62256" stroke="currentColor" stroke-width="1.16341" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="dropdown-options" [class.open]="paginationDropdownOpen">
            <div class="dropdown-option" (click)="selectPaginationOption('10')">10</div>
            <div class="dropdown-option" (click)="selectPaginationOption('25')">25</div>
            <div class="dropdown-option" (click)="selectPaginationOption('50')">50</div>
            <div class="dropdown-option" (click)="selectPaginationOption('100')">100</div>
          </div>
        </div>
        <!-- Range: e.g. "1–10 of 247 stores" -->
        <span class="showing-stores page-range-text">
          {{ currentPage * pageSize + 1 }}–{{ currentPage * pageSize + tableData.length }}
          <ng-container *ngIf="totalItems > 0"> of {{ totalItems }}</ng-container>
          stores
        </span>
      </div>

      <div class="footer-right">
        <span class="coverage-info" *ngIf="coveragePct != null">
          Coverage: {{ coveragePct | number:'1.1-1' }}%
          &nbsp;({{ filteredStoreCount }}/{{ totalBannerStoreCount }} stores)
        </span>
      </div>
    </div>

    <!-- Bottom Row: Pagination Controls -->
    <div class="footer-bottom-row">
      <button class="pagination-button previous"
              [disabled]="currentPage === 0 || isLoading"
              (click)="goToPreviousPage()">
        <svg class="arrow-icon" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.8332 10.9315H4.1665M4.1665 10.9315L9.99984 16.7648M4.1665 10.9315L9.99984 5.09814" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Previous</span>
      </button>

      <div class="footer-center">
        <span class="page-info">Page {{ currentPage + 1 }} of {{ totalPages }}</span>
      </div>

      <button class="pagination-button next"
              [disabled]="currentPage >= totalPages - 1 || isLoading"
              (click)="goToNextPage()">
        <span>Next</span>
        <svg class="arrow-icon" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.1665 10.9315H15.8332M15.8332 10.9315L9.99984 5.09814M15.8332 10.9315L9.99984 16.7648" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
